import { createSlice } from "@reduxjs/toolkit";
import { getAllProductsInGroupsAPI } from "../../services/getAllProductsInGroups";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getAllProductsInGroupsSlice = createSlice({
  name: "getAllProductInGroupsList",
  initialState: data,
  reducers: {
    getAllProductsIngroupsInfo(state) {
      state.isLoading = true;
    },
    getAllProductsIngroupsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getAllProductsIngroupsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getAllProductsIngroupsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getAllProductsInGroupsHandler = (data) => async (dispatch) => {
  try {
    dispatch(getAllProductsIngroupsAction.getAllProductsIngroupsInfo());
    const response = await getAllProductsInGroupsAPI(data);
    dispatch(getAllProductsIngroupsAction.getAllProductsIngroupsInfoSuccess(response));
  } catch (e) {
    dispatch(getAllProductsIngroupsAction.getAllProductsIngroupsInfoFailure(e?.response?.data?.message));
  }
};
export default getAllProductsInGroupsSlice.reducer;
export const getAllProductsIngroupsAction = getAllProductsInGroupsSlice.actions;
